module.exports = __webpack_public_path__ + "media/images/Emblem_of_the_IFRC-da326b28739965a273be01dc96aadc80.png";